import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { CircularProgress, TextField } from "@mui/material";

import styles from "./payment-form.module.scss";
import { styled } from "@mui/material/styles";
import axios from "axios";

const PREFIX = "payment-form";

const classes = {
  field: `${PREFIX}-field`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.field}`]: {
    width: "100% !important",
    // maxWidth: "360px !important",
    height: "40px !important",
    marginBottom: "20px !important",
    transition: "0.2s !important",
    paddingLeft: "20px !important",
    paddingRight: "4px !important",
    fontFamily: "Mulish !important",
    fontWeight: "500 !important",
    fontSize: "19px !important",
    overflow: "hidden !important",
    "&.MuiInput-underline:before": {
      borderBottom: "2px solid #d3d6db",
    },
    // "&.MuiInput-underline:after": {
    //   borderBottom: "2px solid blue",
    // },
    "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "2px solid #d3d6db",
    },
    // borderBottom: "none !important",
    // "& .MuiOutlinedInput-notchedOutline": {
    //   borderWidth: "1px",
    // },
    // "&:hover .MuiOutlinedInput-notchedOutline": {
    //   border: "1px solid rgba(0, 0, 0, 0.23) !important",
    //   "& .MuiOutlinedInput-notchedOutline": {
    //     borderWidth: "1px",
    //   },
    // },
    // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    //   border: "1px solid rgba(0, 0, 0, 0.23) !important",
    //   "& .MuiOutlinedInput-notchedOutline": {
    //     borderWidth: "1px",
    //   },
    // },
  },
}));

const PaymentForm = () => {
  const API_ROOT = process.env.REACT_APP_API_ROOT;

  const [isLoading, setIsLoading] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const isAmount = searchParams.get("amount") === "true";
  const isPhone = searchParams.get("phone") === "true";
  const isEmail = searchParams.get("email") === "true";
  const isOrderNumber = searchParams.get("orderNumber") === "true";
  const isExtraInfo = searchParams.get("extraInfo") === "true";
  const extraInfoText = searchParams.get("extraInfoText");
  const qrID = searchParams.get("qrID");

    // Функция для декодирования extraInfoText
  const decodeExtraInfoText = (text) => {
    if (!text) return "";
    
    try {
      // Заменяем + на пробелы и декодируем остальные URL-символы
      let decoded = text.replace(/\+/g, ' ');
      decoded = decodeURIComponent(decoded);
      // Убираем кавычки если они есть
      decoded = decoded.replace(/^"|"$/g, '');
      return decoded;
    } catch (error) {
      console.error('Error decoding extraInfoText:', error);
      return text || "";
    }
  };

  const decodedExtraInfoText = decodeExtraInfoText(extraInfoText);

  const schema = yup.object().shape({
    amount: yup.mixed().required("Введите значение"),
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(schema),
    defaultValues: {
      phone: "998",
    },
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    console.log("Data", data);

    const { phone, ...newData } = data;

    const formedData = {
      ...newData,
      amount: Number(data?.amount?.replace(/\s+/g, "").replace(".", "")),
      qrID: Number(qrID),
    };

    if (isPhone && phone?.length > 3) {
      formedData.phone = phone;
    }

    try {
      const response = await axios.post(
        `${API_ROOT}/api/v1/ecomm/payments/invoice/create/qr`,
        formedData
      );
      window.location.href = response.data.data?.url;
    } catch (error) {
      console.log(error);
      alert(error?.data?.error_note || "Произошла ошибка");
      console.error(
        "Ошибка при отправке данных:",
        error?.data?.error_note || "Произошла ошибка"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Функция для обработки изменения ввода
  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Удаляем всё, кроме цифр

    // Если пользователь полностью очистил поле, оставляем только "998"
    if (value.length < 3) {
      value = "998";
    }

    // Оставляем только первые 9 символов после "998"
    value = "998" + value.slice(3, 12);

    setValue("phone", value);
  };

  return (
    <Root className={styles.container}>
      <form
        className={styles.form}
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        {isAmount && (
          <div>
            <Controller
              control={control}
              name="amount"
              render={({ field }) => (
                <TextField
                  variant="standard"
                  placeholder="Сумма оплаты"
                  type="text"
                  size="small"
                  fullWidth={true}
                  error={!!errors?.amount}
                  helperText={errors?.amount?.message}
                  onChange={(e) => {
                    const input = e.target;
                    const initialValue = input.value;
                    const initialCursorPosition = input.selectionStart ?? 0;

                    // Split value by decimal point
                    const parts = initialValue.split(".");
                    let intPart = parts[0] || "";
                    let decimalPart = parts[1] || "";

                    // Remove all non-digits and spaces from integer part
                    let digitsOnly = intPart.replace(/\D/g, "");
                    
                    // Handle empty input
                    if (digitsOnly === "") {
                      field.onChange("");
                      return;
                    }

                    // Format integer part with spaces
                    const formattedIntPart = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    
                    // Limit decimal part to 2 digits
                    decimalPart = decimalPart.slice(0, 2);
                    
                    // Construct final value - always add .00 for initial input
                    let formattedValue = formattedIntPart + "." + (decimalPart || "00");
                    
                    field.onChange(formattedValue);

                    // Calculate cursor position - keep cursor in integer part during typing
                    setTimeout(() => {
                      let newCursorPosition = initialCursorPosition;
                      
                      // If cursor was in integer part, adjust for added spaces but keep it in integer part
                      if (initialCursorPosition <= intPart.length) {
                        const digitsBeforeCursor = intPart.substring(0, initialCursorPosition).replace(/\D/g, "").length;
                        const spacesBeforeCursor = digitsBeforeCursor > 3 ? Math.floor((digitsBeforeCursor - 1) / 3) : 0;
                        newCursorPosition = digitsBeforeCursor + spacesBeforeCursor;
                      } else {
                        // If cursor was in decimal part, position after decimal point
                        newCursorPosition = formattedIntPart.length + 1 + Math.min(initialCursorPosition - initialValue.indexOf(".") - 1, decimalPart.length);
                      }
                      
                      newCursorPosition = Math.min(newCursorPosition, formattedValue.length);
                      input.setSelectionRange(newCursorPosition, newCursorPosition);
                    }, 0);
                  }}
                  value={field.value}
                  InputProps={{
                    classes: {
                      root: classes.field,
                    },
                  }}
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9\\. ]*",
                    sx: {
                      width: "100%", // Растягивается на всю доступную ширину
                      maxWidth: "360px", // Ограничиваем до 360px
                      "&::placeholder": {
                        color: "#9097a3",
                        opacity: 1,
                        fontSize: "19px",
                      },
                    }, // Изменение цвета placeholder
                  }}
                />
              )}
            />
          </div>
        )}
        {isPhone && (
          <div className={styles["m-b-12"]}>
            <Controller
              control={control}
              name="phone"
              render={({ field }) => (
                <TextField
                  label="Телефон получателя"
                  variant="standard"
                  // placeholder="Телефон получателя"
                  type="text"
                  size="small"
                  fullWidth={true}
                  error={!!errors?.phone}
                  helperText={errors?.phone?.message}
                  onChange={(e) => {
                    field.onChange(e);
                    handleCardNumberChange(e);
                  }}
                  value={field.value}
                  // onChange={(e) => {
                  //   e.target.value = normalizePhoneNumber(e.target.value);
                  // }}
                  InputProps={{
                    sx: {
                      width: "100%", // Растягивается на всю доступную ширину
                      maxWidth: "360px", // Ограничиваем до 360px
                    },
                    maxLength: 12,
                    classes: {
                      root: classes.field,
                    },
                  }}
                />
              )}
            />
          </div>
        )}
        {isEmail && (
          <div>
            <Controller
              control={control}
              name="email"
              render={({ field }) => (
                <TextField
                  variant="standard"
                  placeholder="Ваш email"
                  type="text"
                  size="small"
                  fullWidth={true}
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                  InputProps={{
                    classes: {
                      root: classes.field,
                    },
                  }}
                  inputProps={{
                    sx: {
                      width: "100%", // Растягивается на всю доступную ширину
                      maxWidth: "360px", // Ограничиваем до 360px
                      "&::placeholder": {
                        color: "#9097a3",
                        opacity: 1,
                        fontSize: "19px",
                      },
                    }, // Изменение цвета placeholder
                  }}
                />
              )}
            />
          </div>
        )}
        {isOrderNumber && (
          <div>
            <Controller
              control={control}
              name="order_number"
              render={({ field }) => (
                <TextField
                  variant="standard"
                  placeholder="Номер заказа"
                  type="text"
                  size="small"
                  fullWidth={true}
                  error={!!errors?.order_number}
                  helperText={errors?.order_number?.message}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                  InputProps={{
                    classes: {
                      root: classes.field,
                    },
                  }}
                  inputProps={{
                    sx: {
                      width: "100%", // Растягивается на всю доступную ширину
                      maxWidth: "360px", // Ограничиваем до 360px
                      "&::placeholder": {
                        color: "#9097a3",
                        opacity: 1,
                        fontSize: "19px",
                      },
                    }, // Изменение цвета placeholder
                  }}
                />
              )}
            />
          </div>
        )}
        {isExtraInfo && (
          <div>
            <Controller
              control={control}
              name="extra_info"
              render={({ field }) => (
                <TextField
                  variant="standard"
                  placeholder={decodedExtraInfoText}
                  type="text"
                  size="small"
                  fullWidth={true}
                  error={!!errors?.extra_info}
                  helperText={errors?.extra_info?.message}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                  InputProps={{
                    classes: {
                      root: classes.field,
                    },
                  }}
                  inputProps={{
                    sx: {
                      width: "100%", // Растягивается на всю доступную ширину
                      maxWidth: "360px", // Ограничиваем до 360px
                      "&::placeholder": {
                        color: "#9097a3",
                        opacity: 1,
                        fontSize: "19px",
                      },
                    }, // Изменение цвета placeholder
                  }}
                />
              )}
            />
          </div>
        )}
        <div className={styles["bottom-row"]}>
          <button type="submit" className={styles["next-button"]}>
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Перейти к оплате"
            )}
          </button>
        </div>
      </form>
    </Root>
  );
};

export default React.memo(PaymentForm);
